module.exports = __webpack_public_path__ + "static/media/template_s5.8a09d347.jpg";